import styled from 'styled-components';
import { TRANSITION_SETTINGS, ICON_CONTAINER_WIDTH, SIDEBAR_PADDING } from '../config.js';
import { themeGet } from '../../../foundation/theme/themeGet/get.js';
import { pxToRem } from '../../../foundation/spacing/utils.js';

var SIDEBAR_MENU_WIDTH = pxToRem(260);
var SIDEBAR_MENU_WIDTH_MINIMIZED = "calc(" + ICON_CONTAINER_WIDTH + " + " + SIDEBAR_PADDING + " * 2)";
var SidebarMenuContainer = styled.div.withConfig({
  displayName: "SidebarMenuContainer",
  componentId: "sc-1ecduz9-0"
})(["width:", ";min-width:", ";flex-shrink:0;overflow:hidden;height:100%;display:flex;flex-direction:column;background-color:", ";border-right:solid ", " ", ";transition:width ", ";", ";"], SIDEBAR_MENU_WIDTH, SIDEBAR_MENU_WIDTH_MINIMIZED, themeGet('colors.background.50'), pxToRem(1), themeGet('colors.border.100'), TRANSITION_SETTINGS, function (_ref) {
  var $minimized = _ref.$minimized;
  return $minimized && "\n    width: " + SIDEBAR_MENU_WIDTH_MINIMIZED + ";\n  ";
});

export { SidebarMenuContainer };
